export default "__VITE_ASSET__CeqTlv2j__"